var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.isUpdateAvailable,"timeout":-1},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"text":"","loading":_vm.isRefreshing,"color":"accent"},on:{"click":_vm.refreshApp}},'v-btn',attrs,false),[_vm._v(" Aktualisieren ")])]}}])},[_vm._v(" Update verfügbar ")])}
var staticRenderFns = []

export { render, staticRenderFns }